import React from "react";
import CustomersPage from "../index";

const CustomerGroups = (props) => {

    return (
        <CustomersPage
            isGroup
            {...props} />
    );
}

export default CustomerGroups;
